module.exports = __webpack_public_path__ + "img/users_plug.webp";